var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrganismFooterNav',{attrs:{"links-col1":_vm.col1,"links-col2":_vm.col2,"links-col3":_vm.col3,"links-col4":_vm.col4,"training":_vm.training,"training-mobile":_vm.trainingMobile,"lk":_vm.lk,"lang":"en"}})
}
var staticRenderFns = []

export { render, staticRenderFns }